import styles from './styles';

export default function PageDivider(): JSX.Element {
  return (
    <>
      <hr className="page-divider"></hr>
      <style jsx>{styles}</style>
    </>
  );
}
